import { render, staticRenderFns } from "./vFormBase.vue?vue&type=template&id=1f62b9c5"
import script from "./vFormBase.vue?vue&type=script&lang=js"
export * from "./vFormBase.vue?vue&type=script&lang=js"
import style0 from "./vFormBase.vue?vue&type=style&index=0&id=1f62b9c5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports